module.exports = import("https://esm.sh/@tiptap/extension-history@2.4.0");;